import { ROLES } from "../api";
import { REGIONS } from "./apiUrls";

const BOTH = [REGIONS.OUS, REGIONS.USA];

export const ROLE_ALLOWED_REGIONS = {
  [ROLES.ADMIN]: BOTH,
  [ROLES.VIEW]: BOTH,
  [ROLES.COMPLIANCE]: BOTH,
  [ROLES.PMS]: BOTH,
  [ROLES.SUPPORT]: [REGIONS.OUS],
  [ROLES.US_APPROVAL]: [REGIONS.USA],
  [ROLES.US_MARKETING]: [REGIONS.USA],
  [ROLES.US_SUPPORT]: [REGIONS.USA],
};

export const getAllowedRegions = (roleName) =>
  ROLE_ALLOWED_REGIONS[roleName] ?? [];
